import {
  API_ADMIN_SET_FEE,
  API_AGENT_CHANGE_USER,
  API_CARD_DETAIL,
  API_CARD_TRANSACTIONS,
  API_CURRENCIES,
  API_PEP_BALANCE,
  API_USER_AGENTS,
  API_USER_CARDS_PLASTIC,
  API_USER_CARDS_VIRTUAL,
  API_USER_DETAIL,
  API_USER_DOCUMENTS,
  API_USER_FEES,
  API_USER_GET_SETTINGS,
  API_USER_INFO,
  API_USER_SET_FEE,
  API_USER_SET_SETTINGS,
  API_USER_TRANSACTIONS,
  API_USER_WALLET,
  API_USER_WALLET_EDIT,
  API_USERS_BALANCE,
  API_USERS_DEFAULT_ADD,
  API_USERS_DEFAULT_GET,
  API_USERS_DEFAULTFEE_ADD,
  API_USERS_DEFAULTFEE_CHECK,
  API_USERS_DEFAULTFEE_DELETE,
  API_USERS_DEFAULTFEE_GET,
  API_USERS_LIST,
  API_USERS_REGISTRATION_COUNT,
} from "./apiPaths";
import axiosMiddleware from "./axiosMiddleware";
// --------------------------------------------------------------------------------
export const getUsersAPI = () => {
  return axiosMiddleware({
    method: "post",
    url: API_USERS_LIST,
  });
};
export const getCurrenciesAPI = () => {
  return axiosMiddleware({
    method: "get",
    url: API_CURRENCIES,
  });
};
export const createUserDefaultWalletAPI = ({ currencies, agentId }) => {
  let postData = {
    currencies,
    agentId,
  };
  return axiosMiddleware({
    method: "post",
    url: API_USERS_DEFAULT_ADD,
    data: postData,
  });
};
export const getUserDefaultsAPI = () => {
  return axiosMiddleware({
    method: "get",
    url: API_USERS_DEFAULT_GET,
  });
};
export const getUserFeesAPI = () => {
  return axiosMiddleware({
    method: "get",
    url: API_USERS_DEFAULTFEE_GET,
  });
};
export const setUserFeesAPI = (data) => {
  return axiosMiddleware({
    method: "post",
    url: API_USER_SET_FEE,
    data,
  });
};
export const setAdminFeesAPI = (data) => {
  return axiosMiddleware({
    method: "post",
    url: API_ADMIN_SET_FEE,
    data,
  });
};
export const createUserFeesAPI = (postData) => {
  return axiosMiddleware({
    method: "post",
    url: API_USERS_DEFAULTFEE_ADD,
    data: postData,
  });
};
export const deleteUserFeesAPI = (postData) => {
  return axiosMiddleware({
    method: "delete",
    url: API_USERS_DEFAULTFEE_DELETE,
    data: postData,
  });
};
export const getUsersBalancesAPI = () => {
  return axiosMiddleware({
    method: "get",
    url: API_USERS_BALANCE,
  });
};
export const getPepBalancesAPI = () => {
  return axiosMiddleware({
    method: "get",
    url: API_PEP_BALANCE,
  });
};
export const getUserInfoAPI = ({ userId }) => {
  let postData = {
    userId: userId,
  };
  return axiosMiddleware({
    method: "post",
    url: API_USER_INFO,
    data: postData,
  });
};
export const getUserDetailsAPI = ({ userId }) => {
  let postData = {
    userId: userId,
  };
  return axiosMiddleware({
    method: "post",
    url: API_USER_DETAIL,
    data: postData,
  });
};

export const getCardDetailsAPI = ({ cardId }) => {
  let postData = {
    cardId: cardId,
  };
  return axiosMiddleware({
    method: "post",
    url: API_CARD_DETAIL,
    data: postData,
  });
};
export const getUserWalletAPI = ({ userId }) => {
  let postData = {
    userId: userId,
  };
  return axiosMiddleware({
    method: "post",
    url: API_USER_WALLET,
    data: postData,
  });
};
export const editWalletMinimumBalanceAPI = ({ walletId, minBalance }) => {
  let postData = {
    walletId,
    minBalance,
  };
  return axiosMiddleware({
    method: "post",
    url: API_USER_WALLET_EDIT,
    data: postData,
  });
};
export const getUserPhysicalCardAPI = ({ userId }) => {
  let postData = {
    userId: userId,
  };
  return axiosMiddleware({
    method: "post",
    url: API_USER_CARDS_PLASTIC,
    data: postData,
  });
};

export const getUserVirtualCardAPI = ({ userId }) => {
  let postData = {
    userId: userId,
  };
  return axiosMiddleware({
    method: "post",
    url: API_USER_CARDS_VIRTUAL,
    data: postData,
  });
};
export const getUserTransactionsAPI = ({ userId, from, to, limit, offset }) => {
  let postData = {
    userId: userId,
    from,
    to,
    limit,
    offset,
  };
  return axiosMiddleware({
    method: "post",
    url: API_USER_TRANSACTIONS,
    data: postData,
  });
};
export const getUserLogsAPI = ({ userId, from, to, limit, offset }) => {
  let postData = {
    userId: userId,
    from,
    to,
    limit,
    offset,
  };
  return axiosMiddleware({
    method: "post",
    url: API_USER_AGENTS,
    data: postData,
  });
};

export const getCardTransactionsAPI = ({ cardId, from, to, limit, offset }) => {
  let postData = {
    cardId,
    from,
    to,
    limit,
    offset,
  };
  return axiosMiddleware({
    method: "post",
    url: API_CARD_TRANSACTIONS,
    data: postData,
  });
};
export const getUserDefaultFeeAPI = (data) => {
  return axiosMiddleware({
    method: "post",
    url: API_USERS_DEFAULTFEE_CHECK,
    data,
  });
};
export const getUsersRegistrationAPI = () => {
  return axiosMiddleware({
    method: "get",
    url: API_USERS_REGISTRATION_COUNT,
  });
};
export const getUsersSettingsAPI = (userId) => {
  return axiosMiddleware({
    method: "post",
    url: API_USER_GET_SETTINGS,
    data: {
      userId,
    },
  });
};
export const setUsersSettingsAPI = (settings) => {
  return axiosMiddleware({
    method: "post",
    url: API_USER_SET_SETTINGS,
    data: settings,
  });
};
export const getUserFeesListAPI = (userId) => {
  return axiosMiddleware({
    method: "post",
    url: API_USER_FEES,
    data: {
      userId,
    },
  });
};
export const getUserDocumentsAPI = (userId) => {
  return axiosMiddleware({
    method: "post",
    url: API_USER_DOCUMENTS,
    data: {
      userId,
    },
  });
};
export const changeUserAgentAPI = ({ userId, agentId }) => {
  return axiosMiddleware({
    method: "post",
    url: API_AGENT_CHANGE_USER,
    data: {
      user_id: userId,
      agent_id: agentId,
    },
  });
};
